import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';
import StyledUserAvatarImage from 'common/theme/user-avatar/StyledUserAvatarImage';
import StyledUserAvatarInitials from 'common/theme/user-avatar/StyledUserAvatarInitials';

function UserAvatar({ border = false, size, textSize = 32, user }) {
  if (!user) return null;

  // Obtener iniciales de manera segura
  const getInitials = () => {
    if (user.first_name && user.last_name) {
      return `${user.first_name.charAt(0)}${user.last_name.charAt(0)}`;
    }
    if (user.full_name) {
      const names = user.full_name.split(' ');
      if (names.length >= 2) {
        return `${names[0].charAt(0)}${names[names.length - 1].charAt(0)}`;
      }
      return user.full_name.charAt(0);
    }
    return '?';
  };

  const displayName = user.full_name || `${user.first_name || ''} ${user.last_name || ''}`.trim();

  return (
    <Box>
      {user.photo ? (
        <StyledUserAvatarImage
          alt={displayName}
          border={border}
          size={size}
          src={user.photo}
        />
      ) : (
        <StyledUserAvatarInitials border={border} size={size} textSize={textSize}>
          {getInitials()}
        </StyledUserAvatarInitials>
      )}
    </Box>
  );
}

UserAvatar.propTypes = {
  border: PropTypes.bool,
  size: PropTypes.number.isRequired,
  textSize: PropTypes.number,
  user: PropTypes.object.isRequired
};

export default UserAvatar;
